import ImageText from "../common/ImageText";
import Counter from "../common/Counter";
import ProductDescription from "../common/ProductDescription";
import Collapsible from "../common/Collapsible";
import TechSpecs from "../common/TechSpecs";
import ProductSlider from "../common/ProductSlider";
import EmailPopup from '../common/EmailPopup';
import "../global.css";
import { Link } from "react-router-dom";
import React, {useEffect, useState} from "react";
import OverlayForm from "../components/OverlayForm";
import { Helmet } from "react-helmet-async";
import SaraPowerTable from "../common/SaraPowerTable";
import ImageTextWithStatus from "../common/ImageTextWithStatus";

export default function Product_SARA() {

  useEffect(() => {
    if (window.location.hash) {
      let newPath = window.location.pathname + window.location.search;
      if (newPath.endsWith('/')) {
        console.log("termina con /", newPath)
        newPath = newPath.slice(0, -1);
        console.log("newPath", newPath)
      }
      window.history.pushState("", document.title, newPath);
    }
  }, []);

  
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [fileType, setFileType] = useState<string | null>(null);

  const handleRequestClick = () => {
    setIsPopupOpen(true);
  };

  const handleClosePopup = () => {
    setIsPopupOpen(false);
  };

  return (
      <div>
          <Helmet>
              <title>SARA | Revolv Space</title>
              <meta name="description" content="SARA is a reliable and user friendly SOLAR ARRAY DRIVE ASSEMBLY for small satellites." />
          </Helmet>

          {/* IMMAGINE PRODOTTO — solo DESKTOP (absolute, com'era) */}
          <div className="hidden md:block">
              <img
                  src="/products/Sara/sarabg.png"
                  alt="Sara"
                  className="absolute mt-[2rem] px-[2rem] md:px-[6rem] lg:px-[10rem] xl:px-[16rem] 2xl:px-[24rem] w-full h-auto object-cover opacity-75 bg-transparent"
                  data-aos="fade-zoom-in"
                  data-aos-offset="200"
                  data-aos-easing="ease-in-sine"
                  data-aos-duration="600"
                  data-aos-once="true"
              />
          </div>

          <div className="relative flex flex-col h-full mt-20">
              {/* TITLE Section — 1 colonna su mobile, 2 su desktop */}
              <div className="grid grid-cols-1 md:grid-cols-2 z-40 mb-s4">

                  {/* Colonna testo */}
                  <div>
                      <h1 className="opacity-0 animate-fadeIn delay-0 md:w-4/6 pb-5 mx-12 mt-12 md:mt-24 2xl:text-7xl xl:text-7xl lg:text-7xl text-4xl leading-120 tracking-tighter text-left uppercase font-bold text-white dark:text-white">
                          SARA
                      </h1>

                      {/* IMMAGINE PRODOTTO — solo MOBILE (in-flow, impilata) */}
                      <img
                          src="/products/Sara/sarabg.png"
                          alt="Sara"
                          className="block md:hidden w-full h-auto px-8 my-6 opacity-90"
                          data-aos="fade-zoom-in"
                          data-aos-offset="200"
                          data-aos-easing="ease-in-sine"
                          data-aos-duration="600"
                          data-aos-once="true"
                      />

                      <div className="opacity-0 animate-fadeIn delay-1 mx-12 uppercase 2xl:text-2xl xl:text-2xl lg:text-2xl pt-8 md:pt-20 text-1xl text-white leading-34 tracking-tight text-left max-w-full md:max-w-1/2">
                          A reliable and <br/>user friendly <br/>SOLAR ARRAY DRIVE ASSEMBLY <br/> for CUBESATS AND MICROSATS <br/> <br/> <strong>TRL 9</strong>
                      </div>
                  </div>

                  {/* Colonna counters */}
                  <div className="col-span-1 flex justify-center md:justify-end z-40 my-16 mb-12">
                      <div className="grid grid-cols-1 flex gap-8 sm:mt-0 text-white md:mr-20">
                          <Counter type="custom" start={0} end={4} unit="" customLabel="MONTH LEAD TIME" upperText="STARTING FROM" />
                          <Counter type="custom" start={0} end={49} unit="K€" customLabel="PER UNIT" upperText="STARTING FROM" />
                          <h1 className="text-md uppercase pt-4 text-center mx-auto w-64">Price and lead times refer to the standard version. Discounts for high-volume orders are possible.</h1>
                      </div>
                  </div>
              </div>
          <div
              className="flex flex-col  sm:flex-row justify-center items-center gap-2 md:gap-16 py-12 font-bold"
              data-aos="fade-zoom-in"
              data-aos-offset="200"
              data-aos-easing="ease-in-sine"
              data-aos-duration="600"
            >
              <Link to="https://sara.revolvspace.com" target="_blank" rel="noopener noreferrer">
              <button
                className="rounded-full w-auto h-12 text-center text-white px-6 md:px-8 transform transition-transform duration-200 hover:scale-110"
                style={{
                  background:
                    "linear-gradient(90deg, #00858F 0%, #E6007E 100%)",
                }}
                onClick={() => {/* handleRequestClick() */}}
              >ACCESS PRODUCT GUIDE
              </button>
              </Link>
              <a href="/pdf/SARA.00.001.rev13_Technical_datasheet.pdf" download="SARA-datasheet.pdf">
                <button
                  className="rounded-full w-auto h-12 text-center text-white px-8 transform transition-transform duration-200 hover:scale-110"
                  style={{
                    background:
                      "linear-gradient(90deg, #00858F 0%, #E6007E 100%)",
                  }}
                  
                >
                  DOWNLOAD DATASHEET
                </button>
              </a>

              <button
                className="rounded-full w-auto h-12 text-center text-white px-8 transform transition-transform duration-200 hover:scale-110"
                style={{
                  background:
                    "linear-gradient(90deg, #00858F 0%, #E6007E 100%)",
                }}
                onClick={() => handleRequestClick()}
              >
                REQUEST QUOTATION
              </button>

              
            </div>
        

        {/*ANIMATED BLOCKS*/}
        <div className="  h-full flex flex-col bg-black bg-opacity-50 z-40 my-20 pt-24">

          <div className=" grid grid-cols-1 md:grid-cols-3 gap-4  sm:mt-0 text-white">
              <Counter
                  type="custom"
                  start={"PCBTLBYLR"}
                  end={"PROVEN"}
                  unit=""
                  customLabel={"AND lifetime-tested \n" + "(60.000 cycles) system"}
                  upperText="FLIGHT"
              />
              <Counter
                  type="custom"
                  start={"PCBTLBYLR"}
                  end={"COMPACT"}
                  unit=""
                  customLabel={"and integrated product \n" +
                      "(drive mechanism + control electronics)"}
                  upperText="HIGHLY"
              /><Counter
              type="custom"
              start={"PCBTLBYLR"}
              end={"MISSION FLEXIBILITY"}
              unit="W"
              customLabel={"FROM CUBESAT TO\n" +
                  "MICROSAT PLATFORMS"}
              upperText="DESIGNED FOR"
          />
          </div>
        </div>
        <div id='main-features' className="h-20"></div>


          {/*AVAILABLE VERSIONS Section*/}
          <div className="h-full flex flex-col bg-black bg-opacity-50 z-40 mb-40 ">

              <h1 data-aos="fade-zoom-in"
                  data-aos-offset="100px"
                  data-aos-delay="0"
                  data-aos-easing="ease-in-sine"
                  data-aos-duration="600"
                  className=" my-12 text-3xl md:text-5xl leading-120 tracking-tighter text-center uppercase font-bold text-white ">
                  AVAILABLE VERSIONS{" "}
              </h1>

              <div>
                  <div className="mt-10 px-4 md:mx-[6rem] lg:mx-[14rem] xl:mx-[20rem] 2xl:mx-[28rem]">
                      <SaraPowerTable/>
                  </div>

                  {/*<div className="grid  md:grid-cols-3  gap-4 px-4 sm:grid-cols-1">
                      <div className="p-4">


                  <div className="value-item "
                       data-aos="fade-zoom-in"
                       data-aos-offset="100px"
                       data-aos-delay="500"
                       data-aos-easing="ease-in-sine"
                       data-aos-duration="600">
                      <ImageText
                          imageSrc="/products/products_1wing.svg"
                          title="SARA-MONO"
                          description={"1 wing per SARA unit\nEach wing controlled independently"}
                          textAlign="center"
                      />
                  </div>
              </div>

              <div className=" p-4">

                  <div className="value-item "
                       data-aos="fade-zoom-in"
                       data-aos-offset="100px"
                       data-aos-delay="800"
                       data-aos-easing="ease-in-sine"
                       data-aos-duration="600">
                      <ImageText
                          imageSrc="/products/products_2wings.svg"
                          title="SARA-DUO"
                          description={"2 wings per SARA unit\nBoth wings controlled together"}
                          textAlign="center"
                      />
                  </div>
              </div>

              <div className="value-item  p-4"
                   data-aos="fade-zoom-in"
                   data-aos-offset="100px"
                   data-aos-delay="1100"
                   data-aos-easing="ease-in-sine"
                   data-aos-duration="600">
                  <ImageText
                      imageSrc="/products/products_geo.svg"
                      title="SARA-GEO"
                      description={"equipped with Radiation-\n"+"HARDENED drive\n" +
                          " electronics (coming soon...)"}
                      textAlign="center"
                  />
              </div>
          </div>*/}

              </div>
          </div>






          {/*DEVELOPING VERSION Section*/}
          <div className="h-full flex flex-col bg-black bg-opacity-50 z-40 mb-40">
              <h1
                  data-aos="fade-zoom-in"
                  data-aos-offset="100px"
                  data-aos-delay="0"
                  data-aos-easing="ease-in-sine"
                  data-aos-duration="600"
                  className="my-12 text-3xl md:text-5xl leading-120 tracking-tighter text-center uppercase font-bold text-white"
              >
                  VERSION IN DEVELOPMENT{" "}
              </h1>

              <div
                  data-aos="fade-zoom-in"
                  data-aos-offset="100px"
                  data-aos-delay="200"
                  data-aos-easing="ease-in-sine"
                  data-aos-duration="600"
                  className="relative mx-auto w-full max-w-[480px] aspect-square px-4"
              >
                  {/* Moon */}
                  <img
                      src="/moon%201.png"
                      alt="SARA Ultra"
                      className="absolute inset-0 w-full h-full object-contain select-none pointer-events-none"
                  />

                  {/* Centered overlay text */}
                  <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-8">
                      <h2 className="text-white font-bold text-xl md:text-2xl mb-4">
                          SARA Ultra
                      </h2>
                      <p className="text-white uppercase text-xs md:text-sm leading-relaxed tracking-wide">
                          Lunar dust-resistant
                          <br />
                          Radiation-hardened
                          <br />
                          Compatible with deep-space
                          <br />
                          thermal cycles
                      </p>
                  </div>
              </div>
          </div>


          <div className="px-10 ">
              <div
                  className="flex items-center justify-center"
                  data-aos="fade-zoom-in"
                  data-aos-offset="200"
                  data-aos-easing="ease-in-sine"
                  data-aos-duration="600"
              >

                  <h1
                      data-aos="fade-zoom-in"
                      data-aos-offset="100px"
                      data-aos-delay="0"
                      data-aos-easing="ease-in-sine"
                      data-aos-duration="600"
                      className="my-12 text-3xl md:text-5xl leading-120 tracking-tighter text-center uppercase font-bold text-white pb-10"
                  >
                      WHY SARA{" "}
                  </h1>
                  <div>
                      <div>
                          {/* GIF sopra l'immagine di sfondo */}
                          {/*<video
                              className="inset-0 w-screen h-full object-cover"
                              loop={true}
                              autoPlay={false}
                              controls
                          >
                              <source src="/SARA_2.0_DIDASCALIE.mp4" type="video/mp4" />
                              Your browser does not support the video tag.
                          </video>*/}
                      </div>
                  </div>

                  {/*immagine product
            <img
              src="/products/SARA_REVOLVSPACE_00_ISOMETRICA 1.svg"
              className="w-auto md:w-5/12  h-auto "
                 alt="sara"
            />*/}
              </div>
              <div>
                  {/*cta download*/}

              </div>

              <div data-aos="fade-zoom-in"
                   data-aos-offset="100px"

                   data-aos-easing="ease-in-sine"
                   data-aos-duration="600"
                   data-aos-once="true">
                  <ProductDescription
                      title="affordability and low lead times"
                      description="SARA’s flexible printed circuit (FPC)-based power transfer technology avoids slip ring technology, guaranteeing low lead times, an affordable price, and high flexibility to adapt to several solar array designs."          />
              </div>

              <div data-aos="fade-zoom-in"
                   data-aos-offset="100px"
                   data-aos-delay="500"
                   data-aos-easing="ease-in-sine"
                   data-aos-duration="600"
                   data-aos-once="true">
                  <ProductDescription
                      title="ENHANCED RADIATION TOLERANCE"
                      description="SARA drive electronics is based on carefully selected, radiation-tolerant, and qualified EEE components, relying on existing radiation data as well as on dedicated TID, proton, and heavy ion tests performed by Revolv Space."
                  />
              </div>
              <div
                  data-aos="fade-zoom-in"
                  data-aos-offset="100px"
                  data-aos-delay="1000"
                  data-aos-easing="ease-in-sine"
                  data-aos-duration="600"
                  data-aos-once="true">
                  <ProductDescription
                      title="HIGH RELIABILITY"
                      description="SARA has been lifetime-tested in thermal vacuum for a total of 60,000 actuation cycles and hundreds of thermal cycles, validating its performance for the whole mission lifetime."
                  />
              </div>
              <div
                  data-aos="fade-zoom-in"
                  data-aos-offset="100px"
                  data-aos-delay="1500"
                  data-aos-easing="ease-in-sine"
                  data-aos-duration="600"
                  data-aos-once="true">
                  <ProductDescription
                      title="EASE OF INTEGRATION"
                      description="SARA is based on a compact and volume-efficient form factor, guaranteeing flexible mounting and an easy integration process."
                  />
              </div>
              <div
                  data-aos="fade-zoom-in"
                  data-aos-offset="100px"
                  data-aos-delay="1500"
                  data-aos-easing="ease-in-sine"
                  data-aos-duration="600"
                  data-aos-once="true">
                  <ProductDescription
                      title="EUROPEAN SUPPLY CHAIN"
                      description="Revolv Space relies on qualified European suppliers, keeping supply chain risks under control."
                  />
              </div>


          </div>




















          {/*           <div id="tech-specs" className="h-10"></div>

          <div  className="h-full flex flex-col bg-black bg-opacity-50 z-40 mb-40">


              <h1
                  data-aos="fade-zoom-in"
                  data-aos-offset="300px"
                  data-aos-delay="0"
                  data-aos-easing="ease-in-sine"
                  data-aos-duration="600"
                  className=" my-12 text-4xl md:text-5xl leading-120 tracking-tighter text-center uppercase font-bold text-white ">
                  TECHNICAL SPECIFICATIONS{" "}
              </h1>

              <div>
                  <div className="grid  md:grid-cols-4  gap-4 px-4 sm:grid-cols-1 " >

                      <div
                          data-aos="fade-zoom-in"
                          data-aos-offset="300px"
                          data-aos-delay="400"
                          data-aos-easing="ease-in-sine"
                          data-aos-duration="600">
                          <TechSpecs
                              title="MECHANICAL SPECIFICATIONS"
                              description={[
                                  { title: "Size: ", description: "97x97x23mm" },
                                  { title: "Mass: ", description: "0.3kg" },
                                  { title: "Rotation range: ", description: " +/- 180°" },
                                  {
                                      title: "Nominal rotation speed: ",
                                      description: " 10 deg/s",
                                  },
                                  { title: "output torque without snapback: ", description: " 70 NMM" },
                                  { title: "Output torque with snapback: ", description: "20 NMM" },
                              ]}

                          />
                      </div>
                      <div
                          data-aos="fade-zoom-in"
                          data-aos-offset="300px"
                          data-aos-delay="700"
                          data-aos-easing="ease-in-sine"
                          data-aos-duration="600"
                      >
                          <TechSpecs
                              title="ELECTRICAL SPECIFICATIONS"
                              description={[
                                  { title: "Power supply:  ", description: "12V (unregulated 10-18V)" },
                                  { title: "power consumption without snapback:  ", description: "Idle: 0.2W\nHOLD: 0.2W\nACTUATION: 5W" },
                                  { title: "power consumption with snapback:  ", description: "Idle: 0.2W\nHOLD: 2W\nACTUATION: 7.5W" },
                                  { title: "power transfer type: ", description: "flex pcb (twist capsule)" },
                                  { title: "maximum current transfer:  ", description: "10 A" },
                                  {
                                      title: "Maximum power transfer: ",
                                      description: "500W @50V",
                                  },
                                  {
                                      title: "Communication interface:  ",
                                      description: "RS485 / CAN",
                                  },
                              ]}

                          />
                      </div>
                      <div
                          data-aos="fade-zoom-in"
                          data-aos-offset="300px"
                          data-aos-delay="1000"
                          data-aos-easing="ease-in-sine"
                          data-aos-duration="600"
                      >
                          <TechSpecs
                              title="THERMAL SPECIFICATIONS"
                              description={[
                                  { title: "Operating  temperature range: ", description: "-40/+60 °C" },
                                  { title: "SURVIVAL temperature range: ", description: "-50/+70 °C" },

                              ]}

                          />
                      </div>
                      <div
                          data-aos="fade-zoom-in"
                          data-aos-offset="300px"
                          data-aos-delay="1300"
                          data-aos-easing="ease-in-sine"
                          data-aos-duration="600"
                      >
                          <TechSpecs
                              title="MODES OF OPERATION"
                              description={[
                                  { title: "Autonomous  ", description: "sun tracking based on sara’s sun sensor data" },
                                  { title: "Freeze ", description: "pauses autonomous actuation for a given time" },
                                  { title: "Slave  ", description: " target angle set by the on-board computer" },
                                  {
                                      title: "Safe ",
                                      description: " panels are (mechanically) returned to the reference angle by snapback",
                                  },
                              ]}

                          />
                      </div>
                  </div>
              </div>
          </div>*/}

        {/* QUALIFICATION Section */}
        <div className="h-full flex flex-col bg-black bg-opacity-50 z-40 mt-4 mb-40" >
          {/* Your content here */}
          <h1
              data-aos="fade-zoom-in"
              data-aos-offset="300px"
              data-aos-delay="0"
              data-aos-easing="ease-in-sine"
              data-aos-duration="600"
              className=" my-12 text-4xl md:text-5xl leading-120 tracking-tighter text-center uppercase font-bold text-white ">
            QUALIFICATION{" "}
          </h1>

          <div>
              <div className="flex flex-wrap justify-center text-center mt-4 gap-4 gap-y-20 px-4 items-center" data-aos="zoom-out-in"
                   data-aos-offset="200"
              data-aos-easing="ease-in-sine"
              data-aos-duration="600">
              <div className="value-itemw-full md:w-[calc(33.333%-1rem)]"

                   data-aos="fade-zoom-in"
                   data-aos-offset="300px"
                   data-aos-delay="400"
                   data-aos-easing="ease-in-sine"
                   data-aos-duration="600">
                <ImageTextWithStatus
                  text="mechanical"
                  imageSrc="/products/product_q_mechanical.svg"
                  description="STATIC LOADS, RANDOM AND SINE VIBRATIONS, AND SHOCK TESTING ACCORDING TO NASA GEVS"
                  textAlign="center"
                />
              </div>
              <div className="value-item w-full md:w-[calc(33.333%-1rem)]"
                   data-aos="fade-zoom-in"
                   data-aos-offset="300px"
                   data-aos-delay="800"
                   data-aos-easing="ease-in-sine"
                   data-aos-duration="600">
                <ImageTextWithStatus
                  text="THERMAL VACUUM"
                  imageSrc="/products/product_q_thermal.svg"
                  description="8 CYCLES IN OPERATIONAL TEMPERATURE RANGE, WITH DEPLOYMENT AND ACTUATION"
                  textAlign="center"
                />
              </div>
              <div className="value-item w-full md:w-[calc(33.333%-1rem)]"
                   data-aos="fade-zoom-in"
                   data-aos-offset="300px"
                   data-aos-delay="1200"
                   data-aos-easing="ease-in-sine"
                   data-aos-duration="600">
                <ImageTextWithStatus
                  text="radiation"
                  imageSrc="/qualifications/radiation new.png"
                  description={"SEE TEST (PROTONS): 30, 50, 100 MEV \n TID TEST: 30 KRAD"}
                  textAlign="center"
                />
              </div>
              <div className="value-item w-full md:w-[calc(33.333%-1rem)]"
                   data-aos="fade-zoom-in"
                   data-aos-offset="300px"
                   data-aos-delay="1600"
                   data-aos-easing="ease-in-sine"
                   data-aos-duration="600">
                <ImageTextWithStatus
                  text="lifetime"
                  imageSrc="/qualifications/LIFETIME.png"
                  description="5 YEARS ACCELERATED LIFETIME TEST IN THERMAL VACUUM"
                  textAlign="center"
                />
              </div>
                <div className="value-item w-full md:w-[calc(33.333%-1rem)]"
                     data-aos="fade-zoom-in"
                     data-aos-offset="300px"
                     data-aos-delay="1800"
                     data-aos-easing="ease-in-sine"
                     data-aos-duration="600">
                    <ImageTextWithStatus
                        text="EMC / EMI"
                        imageSrc="/qualifications/EMC EMI.png"
                        description="According to
ECSS-E-ST-20-07C"
                        textAlign="center"
                    />
                </div>
            </div>
          </div>
        </div>

          {/* COLLAPSIBLE Section */}
          <div className="h-full flex flex-col bg-black bg-opacity-50 z-40 my-40 ">
              {/* Your content here */}
              <h1 data-aos="fade-zoom-in"
                  data-aos-offset="100px"
                  data-aos-delay="0"
                  data-aos-easing="ease-in-sine"
                  data-aos-duration="600"
                  className=" my-12 text-3xl md:text-5xl leading-120 tracking-tighter text-center uppercase font-bold text-white ">
                  product customization & testing options{" "}
              </h1>

              {/*<div className="flex items-center justify-center flex-col"
                   data-aos="fade-zoom-in"
                   data-aos-offset="100px"
                   data-aos-delay="500"
                   data-aos-easing="ease-in-sine"
                   data-aos-duration="600">
                  <Link to="https://drive.google.com/file/d/1i6KW-mnvuOVfgY4QQS4YMGOyQdg07IiX/view?usp=share_link" target="_blank" rel="noopener noreferrer">
                      <button
                          className="rounded-full font-bold w-auto h-12 text-center text-white px-8 my-4 transform transition-transform duration-200 hover:scale-110"
                          style={{
                              background:
                                  "linear-gradient(90deg, #00858F 0%, #E6007E 100%)",
                          }}

                      >
                          DOWNLOAD DATASHEET
                      </button>
                  </Link>
                  <img
                      src="/SARA-mono render esploso.png"
                      className="w-auto md:w-3/12 h-auto"
                      alt="sara"/>
              </div>*/}
              <div>
                  <div
                      className="grid  md:grid-cols-3  gap-4 px-4 sm:grid-cols-1"
                      data-aos="fade-zoom-in"
                      data-aos-offset="100px"
                      data-aos-delay="1000"
                      data-aos-easing="ease-in-sine"
                      data-aos-duration="600"
                  >
                      <div className="flex items-start justify-start ">
                          <Collapsible
                              title="CUSTOMIZATION"
                              additionalText={[
                                  { description: "Customizations on solar array mechanical interfaces" },
                                  { description: "Customizations on solar array electrical interfaces" },

                              ]}

                          />
                      </div>
                      <div className="flex items-start justify-start">
                          <Collapsible
                              title="ACCEPTANCE TESTING"
                              additionalText={[
                                  { description: "Functional acceptance testing" },
                                  { description: "Environmental acceptance testing (vibration, TVAC, run-in)" },

                              ]}

                          />
                      </div>
                      <div className="flex items-start justify-start">
                          <Collapsible
                              title="PRODUCT ASSURANCE"
                              additionalText={[
                                  { description: "Radiation-tolerant BOM" },
                                  { description: "European supply chain" },
                                  { description: "Radiation Lot Acceptance Testing (RLAT)" },

                              ]}

                          />
                      </div>
                  </div>
              </div>
          </div>

          {/* FEATURES IN DEVELOPMENT Section */}
          <div className="h-full flex flex-col bg-black bg-opacity-50 z-40 mt-4 mb-40" >
              {/* Your content here */}
              <h1
                  data-aos="fade-zoom-in"
                  data-aos-offset="300px"
                  data-aos-delay="0"
                  data-aos-easing="ease-in-sine"
                  data-aos-duration="600"
                  className=" my-12 text-4xl md:text-5xl leading-120 tracking-tighter text-center uppercase font-bold text-white ">
                  FEATURES IN DEVELOPMENT{" "}
              </h1>

              <div>
                  <div className="grid text-center mt-4 md:grid-cols-4 gap-4 px-4 sm:grid-cols-1 gap-y-20 align-top " data-aos="zoom-out-in"
                       data-aos-offset="200"
                       data-aos-easing="ease-in-sine"
                       data-aos-duration="600">
                      <div className="value-item "
                           data-aos="fade-zoom-in"
                           data-aos-offset="300px"
                           data-aos-delay="400"
                           data-aos-easing="ease-in-sine"
                           data-aos-duration="600">
                          <ImageTextWithStatus
                              text="AUTONOMOUS SUN TRACKING"
                              imageSrc="/qualifications/sun tracking.png"
                              description=""
                              textAlign="center"
                          />
                      </div>
                      <div className="value-item"
                           data-aos="fade-zoom-in"
                           data-aos-offset="300px"
                           data-aos-delay="800"
                           data-aos-easing="ease-in-sine"
                           data-aos-duration="600">
                          <ImageTextWithStatus
                              text="CAN COMMUNICATION"
                              imageSrc="/qualifications/can communication.png"
                              description=""
                              textAlign="center"
                          />
                      </div>
                      <div className="value-item"
                           data-aos="fade-zoom-in"
                           data-aos-offset="300px"
                           data-aos-delay="1200"
                           data-aos-easing="ease-in-sine"
                           data-aos-duration="600">
                          <ImageTextWithStatus
                              text="SLIP RING-compatible version"
                              imageSrc="/qualifications/slip ring.png"
                              description=""
                              textAlign="center"
                          />
                      </div>
                      <div className="value-item"
                           data-aos="fade-zoom-in"
                           data-aos-offset="300px"
                           data-aos-delay="1600"
                           data-aos-easing="ease-in-sine"
                           data-aos-duration="600">
                          <ImageTextWithStatus
                              text="double winding motor for redundant applications"
                              imageSrc="/qualifications/double winding motor.png"
                              description=""
                              textAlign="center"
                          />
                      </div>
                  </div>
              </div>
          </div>





          {/* VIDEO Section
        <div className="opacity-0 animate-fadeIn delay-0 h-full flex flex-col bg-black bg-opacity-50 z-40">
          {/* <h1 className=" my-12 text-5xl leading-120 tracking-tighter text-center uppercase font-medium text-white ">
                        QUALIFICATION{" "}
                    </h1> 

          <div>
            <div>
              
              <video
                className="inset-0 w-screen h-full object-cover"
                loop={true}
                autoPlay={false}
                controls
              >
                <source src="/SARA_2.0_DIDASCALIE.mp4" type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </div>
          </div>
        </div>*/}

        {/* PRODUCT GALLERY Section */}
        <div className="h-full flex flex-col bg-black bg-opacity-50 z-40 mb-40">
          {/*  */}
          <h1
              data-aos="fade-zoom-in"
              data-aos-offset="300px"
              data-aos-delay="0"
              data-aos-easing="ease-in-sine"
              data-aos-duration="600"
              className="mb-4 mt-40  text-3xl md:text-5xl leading-120 tracking-tighter text-center uppercase font-bold text-white ">
            PRODUCT GALLERY{" "}
          </h1>

          <div data-aos="fade-zoom-in"
               data-aos-offset="300px"
               data-aos-delay="300"
               data-aos-easing="ease-in-sine"
               data-aos-duration="600">
            <ProductSlider />
          </div>
        </div>

          <div className="relative text-white h-full sm:px-10 pt-20">
              {/* Titolo */}
              <h1 data-aos="fade-zoom-in"
                  data-aos-offset="100px"
                  data-aos-delay="0"
                  data-aos-easing="ease-in-sine"
                  data-aos-duration="600"
                  className="my-12 text-3xl md:text-5xl leading-120 tracking-tighter text-center uppercase font-bold text-white">
                  USE CASES{" "}
              </h1>

              {/* Contenitore flex centrato */}
              <div className="flex flex-wrap justify-center gap-x-4">

                  <div className="mt-[4rem] flex flex-col items-center w-full md:w-[calc(33.333%-1rem)]">
                      <img className="my-2 w-[10rem]" style={{ filter: "brightness(0) invert(1)" }} src={"/IMAGES/SARA use cases/satcom.png"} alt="1" />
                      <div className="uppercase text-center">
                          <div className="text-xl">Satellite <br/> communications</div>
                      </div>
                  </div>

                  <div className="mt-[4rem] flex flex-col items-center w-full md:w-[calc(33.333%-1rem)]">
                      <img className="my-2 w-[10rem]" style={{ filter: "brightness(0) invert(1)" }} src={"/IMAGES/SARA use cases/AI on board and edge computing.png"} alt="1" />
                      <div className="uppercase text-center">
                          <div className="text-xl">AI ONBOARD AND <br/> EDGE COMPUTING</div>
                      </div>
                  </div>

                  <div className="mt-[4rem] flex flex-col items-center w-full md:w-[calc(33.333%-1rem)]">
                      <img className="my-2 w-[10rem]" style={{ filter: "brightness(0) invert(1)" }} src={"/IMAGES/SARA use cases/SAR.png"} alt="1" />
                      <div className="uppercase text-center">
                          <div className="text-xl">SEARCH AND RESCUE</div>
                      </div>
                  </div>

                  <div className="mt-[4rem] flex flex-col items-center w-full md:w-[calc(33.333%-1rem)]">
                      <img className="my-2 w-[10rem]" style={{ filter: "brightness(0) invert(1)" }} src={"/IMAGES/SARA use cases/responsive space.png"} alt="1" />
                      <div className="uppercase text-center">
                          <div className="text-xl">RESPONSIVE SPACE</div>
                      </div>
                  </div>

                  <div className="mt-[4rem] flex flex-col items-center w-full md:w-[calc(33.333%-1rem)]">
                      <img className="my-2 w-[10rem]" style={{ filter: "brightness(0) invert(1)" }} src={"/IMAGES/SARA use cases/mid-latitude flights.png"} alt="1" />
                      <div className="uppercase text-center">
                          <div className="text-xl">MID-LATITUDE FLIGHTS</div>
                      </div>
                  </div>

                  <div className="mt-[4rem] flex flex-col items-center w-full md:w-[calc(33.333%-1rem)]">
                      <img className="my-2 w-[10rem]" style={{ filter: "brightness(0) invert(1)" }} src={"/IMAGES/SARA use cases/OTV and space tugs.png"} alt="1" />
                      <div className="uppercase text-center">
                          <div className="text-xl">OTV AND SPACE TUGS</div>
                      </div>
                  </div>

                  <div className="mt-[4rem] flex flex-col items-center w-full md:w-[calc(33.333%-1rem)]">
                      <img className="my-2 w-[10rem]" style={{ filter: "brightness(0) invert(1)" }} src={"/IMAGES/SARA use cases/multi-plane constellations.png"} alt="1" />
                      <div className="uppercase text-center">
                          <div className="text-xl">MULTI-PLANE <br/>CONSTELLATIONS</div>
                      </div>
                  </div>

                  <div className="mt-[4rem] flex flex-col items-center w-full md:w-[calc(33.333%-1rem)]">
                      <img className="my-2 w-[10rem]" style={{ filter: "brightness(0) invert(1)" }} src={"/IMAGES/SARA use cases/GEO.png"} alt="1" />
                      <div className="uppercase text-center">
                          <div className="text-xl">GEOSYNCHRONOUS <br/>EQUATORIAL ORBIT</div>
                      </div>
                  </div>

              </div>
          </div>

        <Link to="/contact">
          <div className="flex items-center justify-center pb-16">
            <button
              className="rounded-full w-auto h-12 text-center text-white px-8 font-bold py-2  transform transition-transform duration-200 hover:scale-110"
              style={{
                background: "linear-gradient(90deg, #00858F 0%, #E6007E 100%)",
              }}
            >
              CONTACT US
            </button>
          </div>
        </Link>
      </div>
      {/* {isPopupOpen && fileType && (
          <EmailPopup fileType={fileType} onClose={handleClosePopup} />
      )}*/}
      {isPopupOpen && (
          <OverlayForm
              formUrl="https://webforms.pipedrive.com/f/6UR9Re8nR5VKrsxbJHNTBDLcsXv6xjIStMZYDU4iiOvEJdEo7cZwg4M1uAm9NAG7WX"
              onClose={handleClosePopup}
          />
      )}
    </div>
  );
}
